import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    font-size: 16px;
    line-height: 1.5;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body {
    font-family: 'McKinsey Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  .appContainer {
    background: ${
      /* istanbul ignore next */
      (props) => props.theme.backgroundColor
    };
    background: ${
      /* istanbul ignore next */
      (props) => props.theme.backgroundImageUrl
    };
    background-size: cover;
    min-height: 100%;
    min-width: 100%;
  }

  /** Default input stylings for Mozilla **/
  input::-webkit-input-placeholder {
    color: #b3b3b3;
    font-weight: 400;
    font-size: 14px;
  }
  input:-moz-placeholder {
    color: #b3b3b3;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }

  /** Alert styles overwriting **/
  .mds-alert[class$="-Alert"] {
    min-width: auto;
    width: 100%;
    overflow: hidden;
  }

  .mds-alert[class$="-Alert"] [class$="-Alert"] {
    width: 100%;
  }

  .mds-alert-content[class$="-Alert"] {
    width: 100%;
  }

  .mds-alert-content[class$="-Alert"] .mds-alert-icon[class$="-Alert"] + div {
    width: 100%;
  }

  @media screen and (max-width: 394px) {
    .mds-alert-content[class$="-Alert"] {
      flex-direction: column;
    }
  }

`

export default GlobalStyle
